import { AnyIfEmpty } from "react-redux";
import { GET_PERMISSION_FAILURE, GET_PERMISSION_SUCCESS, RESET_PERMISSION } from "../constants/setInitialPermission.constant";
import { Module } from "../../../components/roles/rolePermission/RolePermission";

const setPermissions = (permissions: Module[]) => {
    return {
        type: GET_PERMISSION_SUCCESS,
        payload: permissions
    };
};

const noPermissionsFound = () => {
    return {
        type: GET_PERMISSION_FAILURE,
    };
};

export const setUserPermission = (newPermissions: Module[]) => (dispatch: AnyIfEmpty<object>) => {
    dispatch(setPermissions(newPermissions));
};

export const noPermissionsAssigned = () => (dispatch: AnyIfEmpty<object>) => {
    dispatch(noPermissionsFound());
};

export const resetPermission = () => {
    return {
        type: RESET_PERMISSION,
    };
}